import { combineReducers, configureStore } from "@reduxjs/toolkit";
import providerSlice from "./providerSlice";
import requestSlice from "./requestSlice";
import errorSlice from "./errorSlice";
import loaderSlice from "./loaderSlice";
import modalSlice from "./modalSlice";
import headerSlice from "./headerSlice";
import paramsSlice from "./paramsSlice";
import loginSlice from "./loginSlice";

const rootReducer = combineReducers({
  request: requestSlice,
  provider: providerSlice,
  error: errorSlice,
  loader: loaderSlice,
  modal: modalSlice,
  header: headerSlice,
  params: paramsSlice,
  login: loginSlice
});

const store = configureStore({ reducer: rootReducer });

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type IRootState = ReturnType<typeof rootReducer>;

export default store;